import { ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, inject } from '@angular/core';

// Visible countdown for a minimum-stay window. Shows the full duration until
// startTime is set, then ticks down from it to zero.
@Component({
  selector: 'prism-stay-timer',
  templateUrl: './stay-timer.component.html',
  styleUrl: './stay-timer.component.scss'
})
export class StayTimerComponent implements OnChanges, OnDestroy {
  private cdr = inject(ChangeDetectorRef);

  @Input() durationSeconds = 0;
  @Input() startTime: number | null = null;
  @Input() subject = 'course';

  remainingSeconds = 0;
  private timerIntervalId: any = null;

  ngOnChanges(): void {
    this.updateRemaining();
    if (this.timerIntervalId === null && this.remainingSeconds > 0) {
      this.timerIntervalId = setInterval(() => {
        this.updateRemaining();
        this.cdr.markForCheck();
      }, 1000);
    }
  }

  private updateRemaining(): void {
    if (this.startTime === null) {
      this.remainingSeconds = this.durationSeconds;
      return;
    }
    const elapsed = Date.now() - this.startTime;
    this.remainingSeconds = Math.max(0, Math.ceil((this.durationSeconds * 1000 - elapsed) / 1000));

    if (this.remainingSeconds === 0) {
      this.stopTicker();
    }
  }

  private stopTicker(): void {
    if (this.timerIntervalId !== null) {
      clearInterval(this.timerIntervalId);
      this.timerIntervalId = null;
    }
  }

  get timerComplete(): boolean {
    return this.remainingSeconds === 0;
  }

  get minStayDuration(): string {
    const seconds = this.durationSeconds;
    if (seconds < 60) {
      return `${seconds} second${seconds === 1 ? '' : 's'}`;
    }
    const minutes = Math.round(seconds / 60);
    return `${minutes} minute${minutes === 1 ? '' : 's'}`;
  }

  get timerHours(): string {
    return this.pad(Math.floor(this.remainingSeconds / 3600));
  }

  get timerMinutes(): string {
    return this.pad(Math.floor((this.remainingSeconds % 3600) / 60));
  }

  get timerSeconds(): string {
    return this.pad(this.remainingSeconds % 60);
  }

  private pad(value: number): string {
    return value.toString().padStart(2, '0');
  }

  ngOnDestroy(): void {
    this.stopTicker();
  }
}
